// @flow

import { depositSlipActions } from './depositSlipActionCreator';

const initialState = {
  fetching: null,
  fetched: null,
  slipGenerationSuccessful: false
};

const depositSlipReducers = (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case depositSlipActions.GET_DEPOSIT_SLIP_DETAILS: {
      return Object.assign({}, state, action.payload);
    }

    case depositSlipActions.GET_UPDATED_DEPOSIT_SLIP_DETAILS: {
      return Object.assign({}, state, action.payload);
    }

    case depositSlipActions.GET_FILTERED_DATA_DEPOSIT_SLIP: {
      return Object.assign({}, state, {
        data: Object.assign({}, state.data, {
          depositSlipRowDTOList: action.payload
        })
      });
    }

    default:
      return state;
  }
};

export default depositSlipReducers;
